import { render } from "./GameConstantsManagement.vue?vue&type=template&id=74a27790&scoped=true"
import script from "./GameConstantsManagement.vue?vue&type=script&lang=js"
export * from "./GameConstantsManagement.vue?vue&type=script&lang=js"

import "./GameConstantsManagement.vue?vue&type=style&index=0&id=74a27790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a27790"]])

export default __exports__